<template>
  
  <div class="fill-height of-y">
    <div class="c-d-flex c-flex-column fill-height c-align-center c-justify-center" v-if="loadingFolders">
      <v-progress-circular
          :size="40"
          :width="3"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <template v-else>
      <v-treeview
          v-if="selectedLabel"
          :items="treeValue"
          item-text="folderName"
          item-key="folderId"
          item-children="children"
          hoverable
          dense
          :transition="true"
          style="cursor: pointer"
          color="secondary"
      >
        <template slot="prepend" slot-scope="{ item, open, leaf }">
          <v-progress-circular
              v-if="loadingNodes.includes(item.folderId)"
              :size="24"
              :width="2"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <v-icon
              v-else
              @dragover="$event.preventDefault();"
              @drop="e => dropped(e, item)"
              @click="$emit('update:selectedLabel', item)"
              :class="item.folderId === selectedLabel.folderId ? 'primary--text' : ''"
          >
            <template v-if="item.folderName === 'Inbox'">inbox</template>
            <template v-else-if="item.folderName === 'Trash'">delete</template>
            <template v-else-if="item.folderName === 'Drafts'">drafts</template>
            <template v-else-if="item.folderName === 'Junk Email'">delete</template>
            <template v-else-if="item.folderName === 'Spam'">not_interested</template>
            <template v-else-if="item.folderName === 'Sent'">send</template>
            <template v-else-if="item.folderName === 'Archive'">archive</template>
            <template v-else>folder</template>
          </v-icon>
        </template>
        
        <template slot="label" slot-scope="{ item, open, leaf }">
          <!--@dragover="allowDrop"-->
          <!--@drop="drop($event, item)"-->
          <div
              style="width: 100%;"
              @dragover="$event.preventDefault();"
              @drop="e => dropped(e, item)"
              @click="$emit('update:selectedLabel', item)"
          >
                  <span
                      :class="item.folderId === selectedLabel.folderId ? 'font-weight-medium secondary--text' : ''">
                      {{ item.folderName }}
                  </span>
          </div>
        
        </template>
      </v-treeview>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: Object,
    selectedAddress: Object,
    selectedLabel: {
      type: Object,
      default: () => {
        return {
          folderId: null
        }
      }
    },
  },
  data() {
    return {
      loadingFolders: false,
      treeValue: null,
      loadingNodes: []
    }
  },
  watch: {
    selectedAddress: {
      handler(val) {
        if(val) {
          this.loadFolders()
        }
      },
      immediate: true
    }
  },
  methods: {
    
    dropped(e, folder) {
      e?.preventDefault()
      const text = e.dataTransfer.getData('text/plain')
      if (!text) return
      try {
        const obj = JSON.parse(text)
        if (obj.type === 'zohoMessages') {
          this.moveMessagesToFolder(folder, obj.data)
        }
      } catch (e) {
        console.log(e)
      }
    },
    
    async moveMessagesToFolder(folder, messages) {
      try {
        
        if (['Drafts', 'Templates', 'Snoozed', 'Sent', 'Outbox', 'Notification'].includes(folder.folderName)) {
          return this.$snack.error('Cannot move messages to this folder')
        }
        
        this.loadingNodes.push(folder.folderId)
        
        await this.$newReq(
            'POST',
            'zoho/messages/moveToFolder',
            {
              tokenId: this.selectedAddress.tokenId,
              folderId: folder.folderId,
              messages: messages,
            }
        )
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingNodes = this.loadingNodes.filter(v => v !== folder.folderId)
      }
    },
    
    async loadFolders() {
      try {
        this.loadingFolders = true
        
        if (!this.selectedAddress?.tokenId)
          return
        
        const folders = await this.$newReq(
            'POST',
            'zoho/folders',
            {
              tokenId: this.selectedAddress.tokenId
            }
        )
        
        const inboxFolder = folders.find(f => f.path === '/Inbox')
        
        this.$emit('update:selectedLabel', inboxFolder)
        
        this.treeValue = folders
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingFolders = false
      }
    }
  }
}
</script>

<style scoped>

</style>
